<div>
    <h3 class="title" translate>Settings.OrganisationWorkgroupsSection.Title</h3>
</div>

<div class="px-4 py-1">
    <form>
        <div class="row">
            <div class="col-6 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                <input *ngIf="HasWorkgroups" type="text" class="form-control" id="inputSearch" placeholder="{{ 'Settings.OrganisationWorkgroupsSection.Search' | translate }}" (keyup)="applyFilter($event)">
            </div>
            <div class="col-6 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6 text-end">
                <button type="submit" id="buttonSave" class="btn btn-sm btn-secondary me-1" (click)="dialogWorkgroup('add')"><span translate>Settings.OrganisationWorkgroupsSection.AddWorkgroup</span></button>
            </div>
        </div>

        <app-workgroupList [organisation]="organisation.organisation" [workgroups]="workgroups" [workgroupList]="workgroupList" [filter]="filter" (refreshWorkgroups)="refresh()"></app-workgroupList>
    </form>
</div>